import request from '@/utils/request'

import { tokenurl, f10url, getwayurl, searchurl,auth } from './config'
type dataType = any
export default {
  getToken(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: tokenurl,
      method: 'post',
      data: auth,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  getlatest(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/value/f10/latest',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 资讯公告
  getnewsnotice(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/info/f10/news/notice',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  getResearchDetail(data: dataType): Promise<{
    response?: Response
  }> { // 调研活动
    return request({
      url: f10url + '/infoapi/v2/report/org/ResearchDetail',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  getGszxDetail(data: dataType): Promise<{
    response?: Response
  }> { // 公司资讯 // 改为公司看点 2022/3/1 9:30
    return request({
      url: f10url + '/infoapi/v2/info/news/v2',
      // url:"https://www.fastmock.site/mock/2a805c52790d8c0a803220187f85e0b6/f10/getGszx",
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  getReportDetail(data: dataType): Promise<{
    response?: Response
  }> { // 研究报告
    return request({
      url: f10url + '/infoapi/v2/report/list/v4',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 详细情况
  getorginfo(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/base/companyInfo',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 发行相关
  getipoinfo(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/base/ipobaseinfo',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 公司高管
  getleadershare(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/ShareholderF10LeaderShare',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 股本结构总览
  getcapitalstructure(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/ShareholderF10CapitalStructure',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 经营分析总览
  getbusinessanalysis(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/BaseF10BusinessAnalysis',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 股东研究总览
  getholderresearch(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/shareholder/f10/holder/research',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 持股变动分页
  getholderholdchange(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/shareholder/f10/holder/holdchange',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 基金持股分页
  getholderfundhold(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/shareholder/f10/holder/fundhold',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 限售解禁分页
  getholderliftdetail(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/shareholder/f10/holder/liftdetail',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 股东详情
  getholderholdestockhis(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/shareholder/f10/holder/holdestockhis',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 盈利预测
  getprofitforecast(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/finance/f10/profit/forecast',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 预测明细
  getprofitforecastDetail(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/finance/f10/profit/forecastDetail',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 分红融资概要
  getMarginF10DividendFinance(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/MarginF10DividendFinance',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 公司大事概要
  getBigevent(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/value/f10/bigevent',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 重要事项
  getMajor(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/value/f10/bigevent/major',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 行业对比总览
  getInfoF10IndustryComparison(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/InfoF10IndustryComparison',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 行业地位
  getInfoF10IndustryPlace(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/InfoF10IndustryPlace',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 十个报告期
  getInfoF10IndustryEndDate(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/InfoF10IndustryEndDate',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 财务指标
  getFinanceF10(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/FinanceF10',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 财务报告
  getCWF10(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/DataDlFinanceReport',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 指数概况
  baseIndexF10Overview(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/BaseIndexF10Overview',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 估值信息
  baseIndexF10ValuationTrend(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/BaseIndexF10ValuationTrend',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 行业权重
  baseIndexF10IndustryWeight(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/BaseIndexF10IndustryWeight',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 十大权重股
  baseIndexF10Top10Stock(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/BaseIndexF10Top10Stock',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  }

}
